import { paths } from 'src/routes/paths';

import { Icons } from './config';

export const navDataTeacher = [
  {
    subheader: '',
    items: [
      {
        title: 'Khóa học',
        path: paths.teacher.courseManage.table,
        icon: Icons.course,
        children: [
          {
            title: 'Danh sách khóa học',
            path: paths.teacher.courseManage.table,
            children: [
              // { title: 'Tree Folder', path: paths.teacher.courseManage.root },
              { title: 'Table', path: paths.teacher.courseManage.table },
              { title: 'Thêm mới khóa học', path: paths.teacher.courseManage.new },
            ],
          },
        ],
      },
      {
        title: 'Học viên',
        path: paths.teacher.user.root,
        icon: Icons.user,
        children: [
          { title: 'Danh sách người dùng', path: paths.teacher.user.list },
          { title: 'Thêm mới người dùng', path: paths.teacher.user.new },
        ],
      },

      {
        title: 'Lịch',
        path: paths.teacher.calendarManage.root,
        icon: Icons.calendar,
        children: [
          {
            title: 'Lịch học',
            path: paths.teacher.calendarManage.schedule.root,
            children: [
              {
                title: 'Danh sách lịch học',
                path: paths.teacher.calendarManage.schedule.root,
              },
              { title: 'Thêm lịch học', path: paths.teacher.calendarManage.schedule.new },
            ],
          },
          {
            title: 'Lịch họp',
            path: paths.teacher.calendarManage.meetingSchedule.root,
            children: [
              {
                title: 'Danh sách lịch họp',
                path: paths.teacher.calendarManage.meetingSchedule.root,
              },
              {
                title: 'Thêm lịch họp',
                path: paths.teacher.calendarManage.meetingSchedule.new,
              },
            ],
          },
          {
            title: 'Lịch thi',
            path: paths.teacher.calendarManage.testSchedule.root,
            children: [
              {
                title: 'Danh sách lịch thi',
                path: paths.teacher.calendarManage.testSchedule.root,
              },
              { title: 'Thêm lịch thi', path: paths.teacher.calendarManage.testSchedule.new },
            ],
          },
        ],
      },
      // {
      //   title: 'Xuất báo cáo',
      //   path: paths.teacher.exportReport.root,
      //   icon: Icons.export,
      //   children: [
      //     { title: 'Báo cáo chi tiết', path: paths.teacher.exportReport.detailReport },
      //     { title: 'Báo cáo tuần', path: paths.teacher.exportReport.weeklyReport },
      //     {
      //       title: 'Báo cáo bảng điểm cuối khóa',
      //       path: paths.teacher.exportReport.academicTranscript,
      //     },
      //     { title: 'Biểu đồ thống kê', path: paths.teacher.exportReport.chartReport },
      //   ],
      // },
      { title: 'Chat', path: paths.teacher.chat, icon: Icons.chat },
      // {
      //   title: 'Thông báo',
      //   path: paths.teacher.notify.root,
      //   icon: Icons.notify,
      //   children: [
      //     { title: 'Danh sách thông báo', path: paths.teacher.notify.root },
      //     { title: 'Thêm mới thông báo', path: paths.teacher.notify.new },
      //   ],
      // },
      // {
      //   title: 'Email',
      //   path: paths.teacher.email.root,
      //   icon: Icons.email,
      //   children: [
      //     {
      //       title: 'Email',
      //       path: paths.teacher.email.root,
      //       info: (
      //         <Label color="error" variant="inverted">
      //           +32
      //         </Label>
      //       ),
      //     },
      //     { title: 'Mẫu Email', path: paths.teacher.email.template },
      //   ],
      // },
      {
        title: 'Câu hỏi',
        path: paths.teacher.question.question.list,
        icon: Icons.question,
        children: [
          {
            title: 'Ngân hàng câu hỏi',
            path: paths.teacher.question.question.list,
            children: [
              { title: 'Danh sách câu hỏi', path: paths.teacher.question.question.list },
              { title: 'Thêm mới câu hỏi', path: paths.teacher.question.question.create },
              { title: 'Thêm mới câu hỏi (excel)', path: paths.teacher.question.question.excel },
            ],
          },
          {
            title: 'Bộ câu hỏi',
            path: paths.teacher.question.groups.list,
            children: [
              { title: 'Danh sách bộ câu hỏi', path: paths.teacher.question.groups.list },
              { title: 'Thêm mới bộ câu hỏi', path: paths.teacher.question.groups.create },
            ],
          },
          {
            title: 'Ngân hàng đề thi',
            path: paths.teacher.question.exam.list,
            children: [
              { title: 'Danh sách đề thi', path: paths.teacher.question.exam.list },
              { title: 'Thêm mới đề thi ', path: paths.teacher.question.exam.create },
            ],
          },
          {
            title: 'Khảo sát',
            path: paths.teacher.question.survey.list,
            children: [
              { title: 'Danh sách khảo sát', path: paths.teacher.question.survey.list },
              { title: 'Thêm mới khảo sát', path: paths.teacher.question.survey.create },
            ],
          },
        ],
      },
      // { title: 'Mentoring 1:1', path: paths.teacher.mentoring, icon: Icons.calendar },
      // {
      //   title: 'Chứng chỉ',
      //   path: paths.teacher.certificate.root,
      //   icon: Icons.certificate,
      //   children: [{ title: 'Danh sách chứng chỉ', path: paths.teacher.certificate.root }],
      // },
    ],
  },
];
